import NextStepsWidget from 'modules/dashboard/components/NextStepsWidget/NextStepsWidget';

export default NextStepsWidget;
